module.exports = __webpack_public_path__ + "static/media/builtinv2-wifi 2.f07732c0.png";